import Webcam from "react-webcam";
import { BallonCard } from "./style";
import { StartSelfie } from "../startSelfie";
import { SelectSelfieMode } from "../selectSelfieMode";
import { UploadSelfieFile } from "../uploadSelfieFile";
import { CgArrowLeft } from "react-icons/cg";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { useCallback, useEffect, useRef, useState } from "react";
import { useTheme } from "../../../../../../../../../../hooks/WebCheckinUsers/theme";
import { inactiveItens } from "../../../../../../../../../../theme";
import { PhotoIcon } from "../../../../../../../../../../components/SvgComponents/Icons/PhotoIcon";
import ButtonWebCheckinUser from "../../../../../../../../../../components/ButtonWebCheckinUser/index";
import { InstructionStep } from "../../../../../../../../../../components/SvgComponents/Icons/InstructionStep";
import { useGlobalWebCheckinUser } from "../../../../../../../../../../hooks/WebCheckinUsers/global";
import { PhoneIcon } from "../../../../../../../../../../components/SvgComponents/Icons/PhoneIcon";
import { useApiWebCheckinUser } from "../../../../../../../../../../hooks/WebCheckinUsers/api";
import { useWallet } from "../../../../../../../../../../hooks/wallet";
import { GoodQuality } from "../../../../../../../../../../components/SvgComponents/Icons/GoodQuality";
import { BadQuality, BadQuality2 } from "../../../../../../../../../../components/SvgComponents/Icons/BadQuality";
import { MyCircularProgress } from "../../../../../../../../../../components/MyCircularProgress";
import { InstructSelfieIcon } from "../../../../../../../../../../components/SvgComponents/Icons/SelfieIcon";
import { GuestCheck2 } from "../../../../../../../../../../components/SvgComponents/Icons/GuestCheck";
import {
  getComparePhotoMessage,
  getValidatePhotoMessage,
  unmirrorBase64Image,
} from "../../photoValidationMessages";
import {
  isInPageCameraAvailable,
  NativeCameraCapture,
} from "../../nativeCameraCapture";


export interface IStep {
  onNext: () => void;
  goBack: () => void;
}

const StartStep = ({ goBack, onNext }: IStep) => {
  const { colorsTheme } = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Capturar foto</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
            flex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <PhotoIcon />
            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                maxWidth: 300,
                textAlign: "center",
                marginTop: 20,
              }}
            >
              Tire uma foto
            </div>
            <div
              style={{
                fontSize: 14,
                color: "#5B5B5B",
                maxWidth: 250,
                textAlign: "center",
              }}
            >
              Precisamos de uma foto do seu documento de identificação.
            </div>
          </div>
        </div>
        <ButtonWebCheckinUser
          background={colorsTheme.secondary.light}
          color={"#292929"}
          style={{ marginTop: 30 }}
          onClick={onNext}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1,
              padding: "0px 10px",
            }}
          >
            Iniciar captura
          </div>
        </ButtonWebCheckinUser>
      </div>
    </div>
  );
};

const InstructionsStep = ({ goBack, onNext }: IStep) => {
  const { colorsTheme } = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Instruções de envio</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ fontWeight: "bold" }}>Siga as orientações</div>
            <div style={{ fontSize: 14 }}>
              Isso pode facilitar a sua aprovação
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 20,
              marginTop: 40,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Tire o documento do plástico
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Coloque o documento na vertical
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Evite reflexos e sombras
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Verifique a qualidade da foto
              </div>
            </div>
          </div>
        </div>

        <ButtonWebCheckinUser
          background={colorsTheme.secondary.light}
          color={"#292929"}
          style={{ marginTop: 30 }}
          onClick={onNext}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1,
              padding: "0px 10px",
            }}
          >
            Entendi
          </div>
        </ButtonWebCheckinUser>
      </div>
    </div>
  );
};

const InstructionsSelfieStep = ({ goBack, onNext }: IStep) => {
  const { colorsTheme } = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Instruções de envio</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            justifyContent: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <div style={{ fontWeight: "bold" }}>Siga as orientações</div>
            <div style={{ fontSize: 14 }}>
              Isso pode facilitar a sua aprovação
            </div>
          </div>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              gap: 20,
              marginTop: 40,
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Procure um local iluminado
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Retire boné e óculos de sol
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Siga as orientações de captura
              </div>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                gap: 10,
                alignItems: "center",
                minWidth: 250,
              }}
            >
              <InstructionStep />
              <div style={{ color: "#3A3A3A", fontSize: 14 }}>
                Verifique a qualidade da foto
              </div>
            </div>
          </div>
        </div>

        <ButtonWebCheckinUser
          background={colorsTheme.secondary.light}
          color={"#292929"}
          style={{ marginTop: 30 }}
          onClick={onNext}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1,
              padding: "0px 10px",
            }}
          >
            Entendi
          </div>
        </ButtonWebCheckinUser>
      </div>
    </div>
  );
};

const TakeStep = ({
  goBack,
  onNext,
  type,
  onCameraError,
}: Pick<IStep, "goBack"> & {
  onNext: (photo: string) => void;
  type: "front" | "back";
  onCameraError?: () => void;
}) => {
  const { containerGlobalRef, isMobile } = useGlobalWebCheckinUser();
  const { colorsTheme } = useTheme();

  const webcamRef = useRef<Webcam>(null);
  const [cameraError, setCameraError] = useState(false);
  const nativeCamera = !isInPageCameraAvailable();

  const capture = useCallback(() => {
    const imageSrc = webcamRef?.current?.getScreenshot({ width: 1920, height: 1080 });
    if (!imageSrc) return;
    onNext(imageSrc);
  }, [webcamRef, type]);

  let videoWidth = 1920;
  let videoHeight = 1080;

  // Detecta a orientação (paisagem ou retrato)
  const isPortrait = window.innerHeight > window.innerWidth;

  // Ajusta as dimensões para refletir a orientação
  if (isPortrait) {
    [videoWidth, videoHeight] = [1080, 1920];
  }

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "#3D3D3D",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 30,
        maxWidth: "464px",
      }}
    >
      <div
        onClick={goBack}
        style={{
          cursor: "pointer",
          padding: 10,
          position: "absolute",
          right: 0,
          top: 0,
        }}
      >
        <AiOutlineCloseCircle fill="#f7f7f7" size={20} />
      </div>
      {cameraError ? (
        <>
          <BallonCard>
            <div style={{ fontWeight: "bold", fontSize: 18 }}>
              Não foi possível abrir a câmera
            </div>
            <div style={{ fontSize: 14 }}>
              Verifique a permissãoS. Você pode carregar um arquivo
              sem perder o progresso.
            </div>
          </BallonCard>
          {onCameraError && (
            <ButtonWebCheckinUser
              background={colorsTheme.secondary.light}
              color={"#292929"}
              onClick={onCameraError}
              style={{ width: "80%", maxWidth: 320 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flex: 1,
                  padding: "0px 10px",
                }}
              >
                Carregar arquivo
              </div>
            </ButtonWebCheckinUser>
          )}
        </>
      ) : (
        <>
          <BallonCard>
            <div style={{ fontWeight: "bold", fontSize: 18 }}>
              {type === "front"
                ? "Tire uma foto da frente"
                : "Agora tire a foto do verso"}
            </div>
            <div style={{ fontSize: 14 }}>Alinhe o documento no centro</div>
          </BallonCard>
          {nativeCamera ? (
            <NativeCameraCapture
              facingMode="environment"
              onCapture={onNext}
              background={colorsTheme.secondary.light}
              iconColor={colorsTheme.primary.dark}
            />
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <div
                  style={{ border: `2px dashed ${colorsTheme.secondary.light}`, padding: 6, borderRadius: 8 }}
                >
                  <div
                    style={{
                      borderRadius: 8,
                      overflow: "hidden",
                      height: (containerGlobalRef.current?.clientHeight ?? 0) * 0.43,
                      width: (containerGlobalRef.current?.clientWidth ?? 0) * 0.8,
                      display: "flex",
                      flex: 1,
                      padding: 0,
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                  >
                    <Webcam
                      id="webcam-video"
                      ref={webcamRef}
                      audio={false}
                      playsInline
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      mirrored={!isMobile}
                      screenshotFormat="image/jpeg"
                      onUserMediaError={() => setCameraError(true)}
                      videoConstraints={{
                        width: { ideal: videoWidth }, height: { ideal: videoHeight },
                        facingMode: "environment",
                      }}
                    />
                  </div>
                </div>
              </div>
              <div
                style={{
                  padding: 16,
                  borderRadius: "50%",
                  background: colorsTheme.secondary.light,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={capture}
              >
                <PhoneIcon color={colorsTheme.primary.dark} />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

//webcam de selfie
const TakeSelfieStep = ({
  goBack,
  onNext,
  onCameraError,
}: Pick<IStep, "goBack"> & {
  onNext: (photo: string) => void;
  onCameraError?: () => void;
}) => {
  const { containerGlobalRef } = useGlobalWebCheckinUser();
  const { colorsTheme } = useTheme();
  const webcamRef = useRef<Webcam>(null);
  const [cameraError, setCameraError] = useState(false);
  const nativeCamera = !isInPageCameraAvailable();

  const capture = useCallback(async () => {
    const video = webcamRef.current?.video;

    if (video) {
      const width = video.videoWidth;
      const height = video.videoHeight;

      const screenshot = webcamRef.current?.getScreenshot({ width, height });
      if (screenshot) {
        try {
          const unmirrored = await unmirrorBase64Image(screenshot);
          onNext(unmirrored);
        } catch {
          onNext(screenshot);
        }
      }
    }
  }, [onNext]);

  // Definições de resolução baseadas na orientação da tela
  const isPortrait = window.innerHeight > window.innerWidth;

  const videoWidth = isPortrait ? 960 : 1280;
  const videoHeight = isPortrait ? 1280 : 960;

  return (
    <div
      style={{
        position: "absolute",
        inset: 0,
        background: "#3D3D3D",
        width: "100%",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        gap: 30,
      }}
    >
      {/* Botão de fechar */}
      <div
        onClick={goBack}
        style={{
          cursor: "pointer",
          padding: 10,
          position: "absolute",
          right: 0,
          top: 0,
        }}
      >
        <AiOutlineCloseCircle fill="#f7f7f7" size={24} />
      </div>

      {cameraError ? (
        <>
          <BallonCard>
            <div style={{ fontWeight: "bold", fontSize: 18 }}>
              Não foi possível abrir a câmera
            </div>
            <div style={{ fontSize: 14 }}>
              Verifique a permissão ou use HTTPS. Você pode enviar uma foto da
              galeria.
            </div>
          </BallonCard>
          {onCameraError && (
            <ButtonWebCheckinUser
              background={colorsTheme.secondary.light}
              color={"#292929"}
              onClick={onCameraError}
              style={{ width: "80%", maxWidth: 320 }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flex: 1,
                  padding: "0px 10px",
                }}
              >
                Carregar arquivo
              </div>
            </ButtonWebCheckinUser>
          )}
        </>
      ) : (
        <>
          {/* Texto orientação */}
          <BallonCard>
            <div style={{ fontWeight: "bold", fontSize: 18 }}>
              Alinhe o rosto no círculo
            </div>
            <div style={{ fontSize: 14 }}>
              Retire bonés, óculos ou outro acessório
            </div>
          </BallonCard>

          {nativeCamera ? (
            <NativeCameraCapture
              facingMode="user"
              onCapture={onNext}
              background={colorsTheme.secondary.light}
              iconColor={colorsTheme.primary.dark}
            />
          ) : (
            <>
              {/* Área da câmera */}
              <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <div
                  style={{
                    border: `2px dashed ${colorsTheme.secondary.light}`,
                    padding: 8,
                    borderRadius: "50%",
                  }}
                >
                  <div
                    style={{
                      borderRadius: "50%",
                      overflow: "hidden",
                      height: (containerGlobalRef.current?.clientWidth ?? 0) * 0.5625,
                      width: (containerGlobalRef.current?.clientWidth ?? 0) * 0.5625,
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      background: "#000",
                    }}
                  >
                    <Webcam
                      ref={webcamRef}
                      audio={false}
                      playsInline
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                      mirrored
                      screenshotFormat="image/jpeg"
                      onUserMediaError={() => setCameraError(true)}
                      videoConstraints={{
                        width: { ideal: videoWidth },
                        height: { ideal: videoHeight },
                        facingMode: "user",
                      }}
                    />
                  </div>
                </div>
              </div>

              {/* Botão de captura */}
              <div
                style={{
                  padding: 16,
                  borderRadius: "50%",
                  background: colorsTheme.secondary.light,
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  cursor: "pointer",
                }}
                onClick={capture}
              >
                <PhoneIcon color={colorsTheme.primary.dark} />
              </div>
            </>
          )}
        </>
      )}
    </div>
  );
};

const ValidationImageStep = ({
  goBack,
  onNext,
  image,
  isValid = false,
  document_type,
}: IStep & {
  image: string;
  isValid?: boolean;
  document_type: "rg" | "passport" | "license";
}) => {
  const [loading, setLoading] = useState(!isValid);
  const [valid, setValid] = useState(isValid);
  const [reason, setReason] = useState<string | undefined>();
  const { api } = useApiWebCheckinUser();
  const { colorsTheme } = useTheme();
  const validatedImageRef = useRef<string | null>(null);

  useEffect(() => {
    if (isValid) return;
    if (validatedImageRef.current === image) return;
    validatedImageRef.current = image;

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.post("/photos/validate", {
          photo: image,
          kind: "document",
          document_type,
        });
        if (cancelled) return;
        setValid(data.valid);
        setReason(data.reason);
      } catch (e) {
        if (cancelled) return;
        setValid(false);
        setReason("api_error");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [api, document_type, image, isValid]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            {!loading && (
              <div
                style={{ position: "absolute", left: 0 }}
                className="pointer"
                onClick={() => goBack()}
              >
                <CgArrowLeft color={inactiveItens.light} size={20} />
              </div>
            )}
            <div>Verificar documento</div>
          </div>
        </div>
        <div
          style={{ display: "flex", flexDirection: "column", flex: 1, gap: 30 }}
        >
          <div
            style={{
              padding: 16,
              borderRadius: 8,
              background: loading ? "#EFEFEF" : valid ? "#E6FFF2" : "#FFF7F7",
              justifyContent: "center",
              alignItems: "center",
              display: "flex",
              flexDirection: "row",
              gap: 20,
            }}
          >
            {loading && (
              <>
                <MyCircularProgress size={25} color={colorsTheme.secondary.light} />
                <div style={{ fontSize: 14 }}>
                  Verificando se há um rosto na imagem
                </div>
              </>
            )}
            {!loading && valid && (
              <>
                <div style={{ fontSize: 14 }}>
                  <GoodQuality />
                </div>
                <div style={{ fontSize: 14 }}>
                  {getValidatePhotoMessage(reason, true, document_type)}
                </div>
              </>
            )}
            {!loading && !valid && (
              <>
                <div style={{ fontSize: 14 }}>
                  <BadQuality />
                </div>
                <div style={{ fontSize: 14 }}>
                  {getValidatePhotoMessage(reason, false, document_type)}
                </div>
              </>
            )}
          </div>
          <div
            style={{
              padding: 30,
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              background: "#F7F7F7",
              borderRadius: 8,
            }}
          >
            <img style={{ width: "90%", borderRadius: 8 }} src={image} />
          </div>
        </div>
        <ButtonWebCheckinUser
          background={colorsTheme.secondary.light}
          color={"#292929"}
          onClick={onNext}
          disabled={loading || !valid}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1,
              padding: "0px 10px",
            }}
          >
            Salvar e continuar
          </div>
        </ButtonWebCheckinUser>
      </div>
    </div>
  );
};

const PrepareSelfie = ({ goBack, onNext }: IStep) => {
  const { colorsTheme } = useTheme();

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div
              style={{ position: "absolute", left: 0 }}
              className="pointer"
              onClick={() => goBack()}
            >
              <CgArrowLeft color={inactiveItens.light} size={20} />
            </div>
            <div>Capture uma selfie</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: 20,
            flex: 1,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 5,
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <InstructSelfieIcon />
            <div
              style={{
                fontSize: 18,
                fontWeight: "bold",
                maxWidth: 300,
                textAlign: "center",
                marginTop: 20,
              }}
            >
              Tire uma selfie
            </div>
            <div
              style={{
                fontSize: 14,
                color: "#5B5B5B",
                maxWidth: 250,
                textAlign: "center",
              }}
            >
              Precisamos de uma foto do seu rosto para cadastrar sua biometria.
            </div>
          </div>
        </div>
        <ButtonWebCheckinUser
          background={colorsTheme.secondary.light}
          color={"#292929"}
          style={{ marginTop: 30 }}
          onClick={onNext}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              flex: 1,
              padding: "0px 10px",
            }}
          >
            Iniciar captura
          </div>
        </ButtonWebCheckinUser>
      </div>
    </div>
  );
};

const MatchPhotos = ({
  onNext,
  isValid = false,
  image_front,
  image_selfie,
  onFail,
  onRetryDocuments,
  guest,
  document_type,
}: Pick<IStep, "onNext"> & {
  onFail: () => void;
  onRetryDocuments: () => void;
  isValid?: boolean;
  image_front: string;
  image_selfie: string;
  guest: any;
  document_type: "rg" | "passport" | "license";
}) => {
  const { subscription } = useWallet();
  const isHaveFaceMatchPermission = subscription?.plans?.permissions.includes("DOCUMENT_FACE_MATCH");

  const [loading, setLoading] = useState(isHaveFaceMatchPermission && !isValid);
  const [valid, setValid] = useState(!isHaveFaceMatchPermission || isValid);
  const [reason, setReason] = useState<string | undefined>();
  const { api, } = useApiWebCheckinUser();
  const { colorsTheme } = useTheme();
  const comparedRef = useRef(false);

  useEffect(() => {
    if (!isHaveFaceMatchPermission || isValid || comparedRef.current) return;
    comparedRef.current = true;

    let cancelled = false;
    (async () => {
      setLoading(true);
      try {
        const { data } = await api.post("/photos/compare", {
          photo_1: image_front,
          photo_2: image_selfie,
          guest: guest,
          document_type,
        });
        if (cancelled) return;
        setValid(data.valid);
        setReason(data.reason);
      } catch (e) {
        if (cancelled) return;
        setValid(false);
        setReason("api_error");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [api, document_type, guest, image_front, image_selfie, isHaveFaceMatchPermission, isValid]);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "0 20px",
        flex: 1,
      }}
    >
      <div
        style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}
      >
        <div
          style={{
            display: "flex",
            gap: 10,
            justifyContent: "space-between",
            alignItems: "center",
            marginBottom: 10,
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: 18,
              flexDirection: "row",
              display: "flex",
              alignItems: "center",
              gap: 5,
              position: "relative",
              justifyContent: "center",
              flex: 1,
            }}
          >
            <div>{isHaveFaceMatchPermission ? "Verificação da biometria" : "Enviar documentos"}</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          {!isHaveFaceMatchPermission && (
            <>
              <GuestCheck2 />
              <div style={{ fontWeight: "bold", marginTop: 20 }}>
                Documentos salvos
              </div>
              <div style={{ fontSize: 14 }}>
                Os documentos do hóspede foram salvos com sucesso.
              </div>
            </>
          )}
          {loading && isHaveFaceMatchPermission && (
            <>
              <MyCircularProgress size={30} color={colorsTheme.secondary.light} />
              <div style={{ fontWeight: "bold", marginTop: 20 }}>
                Verificação em andamento
              </div>
              <div style={{ fontSize: 14 }}>
                Estamos verificando a biometria fácil do hóspede
              </div>
            </>
          )}
          {!loading && valid && isHaveFaceMatchPermission && (
            <>
              <GuestCheck2 />
              <div style={{ fontWeight: "bold", marginTop: 20 }}>
                {getComparePhotoMessage(reason, true).title}
              </div>
              <div style={{ fontSize: 14 }}>
                {getComparePhotoMessage(reason, true).description}
              </div>
            </>
          )}
          {!loading && !valid && isHaveFaceMatchPermission && (
            <>
              <BadQuality2 />
              <div style={{ fontWeight: "bold", marginTop: 20 }}>
                {getComparePhotoMessage(reason, false).title}
              </div>
              <div style={{ fontSize: 14 }}>
                {getComparePhotoMessage(reason, false).description}
              </div>
            </>
          )}
        </div>
        {!loading && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 12,
              width: "100%",
            }}
          >
            <ButtonWebCheckinUser
              background={colorsTheme.secondary.light}
              color={"#292929"}
              onClick={() => (valid ? onNext() : onFail())}
              disabled={loading}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flex: 1,
                  padding: "0px 10px",
                }}
              >
                {valid ? "Voltar para hóspedes" : "Tentar novamente"}
              </div>
            </ButtonWebCheckinUser>
            {!valid && (
              <ButtonWebCheckinUser
                background="#fff"
                color="#292929"
                borderColor="#8D8D8D"
                onClick={onRetryDocuments}
                disabled={loading}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    flex: 1,
                    padding: "0px 10px",
                  }}
                >
                  Enviar documentação novamente
                </div>
              </ButtonWebCheckinUser>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export const FileInstructionsPhoto: React.FC<
  Pick<IStep, "goBack"> & {
    document_type: "rg" | "passport" | "license";
    onNext: (data: {
      frontImage: string | null;
      backImage: string | null;
      selfieImage: string | null;
    }) => void;
    onSwitchToFileMode: (images: {
      frontImage: string | null;
      backImage: string | null;
    }) => void;
    guest: any;
    isPrimaryGuest: boolean;
  }
> = ({ goBack, onNext, onSwitchToFileMode, document_type, guest, isPrimaryGuest }) => {

  const [step, setStep] = useState<
    | "start"
    | "instructions"
    | "take-front"
    | "take-back"
    | "validation-front"
    | "start-selfie"
    | "select-selfie-mode"
    | "upload-selfie-file"
    | "prepare-selfie"
    | "instructions-selfie"
    | "send-selfie"
    | "match-photos"
  >("start");
  const [frontImage, setFrontImage] = useState<string | null>(null);
  const [backImage, setBackImage] = useState<string | null>(null);
  const [frontIsValid, setFrontIsValid] = useState(false);
  const [selfieImage, setSelfieImage] = useState<string | null>(null);
  const [selfieMode, setSelfieMode] = useState<"file" | "photo">("photo");

  const canChooseSelfieMode = !isPrimaryGuest;

  if (step === "start")
    return <StartStep goBack={goBack} onNext={() => setStep("instructions")} />;

  if (step === "instructions")
    return (
      <InstructionsStep
        goBack={() => setStep("start")}
        onNext={() => setStep("take-front")}
      />
    );

  if (step === "take-front") {
    return (
      <TakeStep
        goBack={() => setStep("instructions")}
        onNext={(photo: string) => {
          setFrontImage(photo);
          setStep("validation-front");
        }}
        type="front"
        onCameraError={() =>
          onSwitchToFileMode({
            frontImage: null,
            backImage: null,
          })
        }
      />
    );
  }

  if (step === "take-back") {
    return (
      <TakeStep
        goBack={() => setStep("validation-front")}
        onNext={(photo: string) => {
          setBackImage(photo);
          setStep("start-selfie");
        }}
        type="back"
        onCameraError={() =>
          onSwitchToFileMode({
            frontImage,
            backImage: null,
          })
        }
      />
    );
  }

  if (step === "validation-front") {
    return (
      <ValidationImageStep
        image={frontImage as any}
        goBack={() => setStep("take-front")}
        onNext={() => {
          setFrontIsValid(true);
          if (document_type !== "rg") setStep("start-selfie");
          else setStep("take-back");
        }}
        isValid={frontIsValid}
        document_type={document_type}
      />
    );
  }

  if (step === "start-selfie") {
    return (
      <StartSelfie
        goBack={() => setStep(document_type !== "rg" ? "validation-front" : "take-back")}
        onNext={() =>
          setStep(canChooseSelfieMode ? "select-selfie-mode" : "prepare-selfie")
        }
        canChooseSelfieMode={canChooseSelfieMode}
      />
    );
  }

  if (step === "select-selfie-mode") {
    return (
      <SelectSelfieMode
        goBack={() => setStep("start-selfie")}
        onNext={(newSelfieMode) => {
          setSelfieMode(newSelfieMode);
          setStep(
            newSelfieMode === "file" ? "upload-selfie-file" : "prepare-selfie"
          );
        }}
      />
    );
  }

  if (step === "upload-selfie-file") {
    return (
      <UploadSelfieFile
        goBack={() =>
          setStep(
            canChooseSelfieMode ? "select-selfie-mode" : "instructions-selfie"
          )
        }
        onNext={(selfie) => {
          setSelfieImage(selfie);
          setStep("match-photos");
        }}
      />
    );
  }

  if (step === "prepare-selfie") {
    return (
      <PrepareSelfie
        goBack={() =>
          setStep(canChooseSelfieMode ? "select-selfie-mode" : "start-selfie")
        }
        onNext={() => setStep("instructions-selfie")}
      />
    );
  }

  if (step === "instructions-selfie") {
    return (
      <InstructionsSelfieStep
        goBack={() => setStep("prepare-selfie")}
        onNext={() => setStep("send-selfie")}
      />
    );
  }

  if (step === "send-selfie") {
    return (
      <TakeSelfieStep
        goBack={() => setStep("instructions-selfie")}
        onNext={(selfie) => {
          setSelfieImage(selfie);
          setStep("match-photos");
        }}
        onCameraError={() => {
          setSelfieMode("file");
          setStep("upload-selfie-file");
        }}
      />
    );
  }

  if (step === "match-photos") {
    return (
      <MatchPhotos
        onFail={() =>
          setStep(selfieMode === "file" ? "upload-selfie-file" : "send-selfie")
        }
        onRetryDocuments={() => {
          setFrontImage(null);
          setBackImage(null);
          setFrontIsValid(false);
          setSelfieImage(null);
          setStep("instructions");
        }}
        image_front={frontImage as any}
        image_selfie={selfieImage as any}
        guest={guest}
        document_type={document_type}
        onNext={() => onNext({ frontImage, backImage, selfieImage })}
      />
    );
  }

  return null;
};
